// extracted by mini-css-extract-plugin
export default {"wrap":"CommandoModeDetail_wrap__69Nn3","block":"CommandoModeDetail_block__Qh4-e","buttonWrap":"CommandoModeDetail_buttonWrap__DQUJo","toogle":"CommandoModeDetail_toogle__FcIbO"};